import { Component, Input, OnInit, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { ToastService } from 'ng-uikit-pro-standard';
import { DocumentoElectronicoService } from 'src/app/services/documento-electronico.service';
import { DocumentoService } from 'src/app/services/documento.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalAgregarDocumentoRecibidoComponent } from './modal-add-doc-recibido/modal-add-doc-recibido.component';
import { ModalConfirmPeriodoGestionComponent } from './modal-confirm-periodo-gestion/modal-confirm-periodo-gestion.component';
import { ModalDocumentoProcesadoResultadoComponent } from './modal-doc-procesado-resultado/modal-doc-procesado-resultado.component';
import { EmpresasRecibidosModalObservacionesNoProcesadasComponent } from './modal-observaciones-no-procesadas/modal-observaciones-no-procesadas.component';

export interface IInputParams {
  desde: Date;
  hasta: Date;
  tipo_dte_codigo: number;
  statusDocumento: number;
}
@Component({
  selector: 'app-empresas-recibidos-table-importacion',
  templateUrl: './table-importacion.component.html',
  styleUrls: ['../empresas-recibidos.component.scss'],
  providers: [SecurityService],
})
export class EmpresasRecibidosTableImportacionComponent implements OnInit {
  @Input() visible: boolean = false;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;
  @ViewChild(ModalConfirmPeriodoGestionComponent, { static: true }) modalConfirmPeriodoGestion: ModalConfirmPeriodoGestionComponent;
  @ViewChild(ModalAgregarDocumentoRecibidoComponent, { static: true }) modalAgregarDocumentoRecibido: ModalAgregarDocumentoRecibidoComponent;
  @ViewChild(ModalDocumentoProcesadoResultadoComponent, { static: true }) modalDocumentoProcesadoResultado: ModalDocumentoProcesadoResultadoComponent;
  @ViewChild(EmpresasRecibidosModalObservacionesNoProcesadasComponent, { static: true }) modalObservacionesNoProcesadas: EmpresasRecibidosModalObservacionesNoProcesadasComponent;

  // Data & Tmp
  rutEmpresa: number;
  sucursalCodigo: number;
  loading: boolean = false;
  listaDocumentos: Array<any> = [];
  listaDocumentosAll: Array<any> = null;
  areSelected: boolean = false;
  paginationContext: PaginationContext = new PaginationContext();
  processing: boolean = false;
  classColorProcesado = 'blue-text';
  classColorBloqueado = 'red-text';
  classColorNoProcesado = 'orange-text';

  params: IInputParams = null;
  ClienteSeleccion: any = null;
  // Utils
  private log: any;

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private documentoElectronicoService: DocumentoElectronicoService,
    public rutService: RutService,
    private fileDownloadService: FileDownloadService,
    private documentoService: DocumentoService
  ) {
    this.log = this.clog.log('EMPRESAS-RECIBIDOS / INTERCAMBIO-EMPRESAS');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());

    this.paginationContext.RecordsByPage = 10;
  }

  loadAndShow(params: IInputParams): boolean {
    try {
      this.clearData();
      this.params = params;
      this.buscar(1);
      return true;
    } catch {
      return false;
    }
  }

  clearData() {
    this.listaDocumentos = null;
    this.listaDocumentosAll = null;
    this.loading = true;
    this.areSelected = false;

    this.paginationContext.CurrentPage = 1;
  }

  buscar(pageNumber: number = 1) {
    this.loading = true;

    this.paginationContext.CurrentPage = pageNumber;

    const { desde, hasta, tipo_dte_codigo, statusDocumento } = this.params;
    const inputParams = {
      empresa_rut: this.rutEmpresa,
      desde,
      hasta,
      tipo_dte_codigo,
      statusDocumento: statusDocumento ? statusDocumento : 0,
      retornaExcel: false,
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1, //this.paginationContext.RecordsByPage
    };

    this.log('inputParams', JSON.stringify(inputParams));
    this.documentoElectronicoService.obtenerRecibidosImportacion(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros } = respuesta;
      this.listaDocumentosAll = registros;

      this.paginationContext.RecordsCount = this.listaDocumentosAll.length; //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage); //totalPaginas
      this.paginationContext.CurrentPage = 1;

      this.listaDocumentosAll.forEach((doc) => {
        doc.rutFormato = this.rutService.AgregarDV(doc.rut);
      });
      this.listaDocumentosAll.forEach((doc, index) => {
        doc.additionalInfo = {};
        doc.additionalInfo.index = index;
        doc.additionalInfo.checked = false;
        doc.additionalInfo.loadingPdf = false;

        doc.envio_rec = true; // TODO: Remove this line. It exists is only for dev purposes
      });

      this.showPage(this.paginationContext.CurrentPage);
      this.loading = false;
    });
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber;
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage;
    this.listaDocumentos = _.slice(this.listaDocumentosAll, start, start + this.paginationContext.RecordsByPage);
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage);
  }

  checkAllChange({ checked }) {
    this.listaDocumentosAll
      .filter((p) => p.envio_rec)
      .forEach((mov) => {
        mov.additionalInfo.checked = checked;
      });
    this.listaDocumentos
      .filter((p) => p.envio_rec)
      .forEach((mov) => {
        mov.additionalInfo.checked = checked;
      });
    this.handleAreSelected();
  }

  checkDetalle({ index }, { checked }) {
    const _indexAll = this.listaDocumentosAll.findIndex((p) => p.additionalInfo.index === index);
    this.listaDocumentosAll[_indexAll].additionalInfo.checked = checked;

    const _indexPage = this.listaDocumentos.findIndex((p) => p.additionalInfo.index === index);
    this.listaDocumentos[_indexPage].additionalInfo.checked = checked;

    this.handleAreSelected();
  }

  handleAreSelected() {
    if (!this.listaDocumentosAll || this.listaDocumentosAll.length == 0) this.areSelected = false;
    this.areSelected = this.listaDocumentosAll.filter((mov) => mov.additionalInfo.checked).length > 0;
  }

  showModalConfirmPeriodoGestion() {
    const listaSelecionados: any[] = this.createPayloadSeleccionados();
    this.modalConfirmPeriodoGestion.loadAndShow({
      acceptCallback: this.ConfirmarDocumentosHaciaERP,
      additionalData: { listaSelecionados },
    });
  }

  private createPayloadSeleccionados(): any[] {
    return this.listaDocumentosAll
      .filter((p) => p.envio_rec && p.additionalInfo.checked)
      .map((doc) => ({
        rut_receptor: doc.rut_receptor,
        rut_emisor: doc.rut_emisor,
        sucursal_codigo: doc.sucursal_codigo,
        tipo_dte_codigo: doc.tipo_dte_codigo,
        folio: doc.folio,
        seleccion: true,
        cliente_nombre: doc.razon_social,
      }));
  }

  ConfirmarDocumentosHaciaERP = (anno: number, mes: number, codigoBodega: number, mueveStock: boolean, additionalData: any) => {
    this.log('ConfirmarDocumentosHaciaERP', anno, mes, codigoBodega, additionalData);
    const { listaSelecionados } = additionalData;

    const inputParams = {
      anno,
      mes,
      sucursal_codigo: this.sucursalCodigo,
      codigoBodega,
      mueveStock,
      lista: listaSelecionados,
    };
    this.processing = true;

    this.log('inputParams', JSON.stringify(inputParams));

    this.documentoService.marcaDocumentoCompraProcesado(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null && respuesta !== undefined;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.processing = false;

        return;
      }
      this.processing = false;
      this.modalDocumentoProcesadoResultado.loadAndShow(respuesta);
      this.buscar(1);
      this.areSelected = false;
    });

    // this.documentoElectronicoService.confirmarDocumentosHaciaERP({
    //   empresa_rut: this.rutEmpresa,
    //   lista_id_lsoft,
    //   periodo: periodoGestion
    // }, ({ mensajes, respuesta }) => {
    //   const ok = respuesta !== null && respuesta !== undefined
    //   if (!ok) {
    //     this.messageRendererService.showErrors(mensajes)
    //     return
    //   }

    //   if (!respuesta) {
    //     this.toastService.error('No se pudo enviar la solicitud')
    //     return
    //   }

    //   this.toastService.success('Solicitud enviada')
    //   this.buscar(this.paginationContext.CurrentPage);
    // })
  };
  onResponse() {
    this.buscar(1);
    this.areSelected = false;
  }

  showModalConfirmNoProcesar() {
    this.modalObservacionesNoProcesadas.show(this.createPayloadSeleccionados());
    // this.modalConfirm.showWithInlineConfig("Confirmar cancelación proceso", "¿Desea cancelar proceso de los documentos seleccionados?", () => {
    //   const listaSelecionados = this.createPayloadSeleccionados()
    //   this.log('listaSelecionados', listaSelecionados)

    //   const inputParams = {
    //     lista: listaSelecionados
    //   }

    //   this.log('inputParams', JSON.stringify(inputParams))

    //   this.documentoService.marcaDocumentoCompraNoProcesado(inputParams, ({ mensajes, respuesta }) => {
    //     const ok = respuesta !== null && respuesta !== undefined
    //     if (!ok) {
    //       this.messageRendererService.showErrors(mensajes)
    //       return
    //     }

    //     this.toastService.success('Operación realizada')
    //     this.buscar(1)
    //     this.areSelected = false
    //   })

    //   // this.documentoElectronicoService.noProcesarDocumentosHaciaERP({
    //   //   empresa_rut: this.rutEmpresa,
    //   //   lista_id_lsoft
    //   // }, ({ mensajes, respuesta }) => {
    //   //   const ok = respuesta !== null && respuesta !== undefined
    //   //   if (!ok) {
    //   //     this.messageRendererService.showErrors(mensajes)
    //   //     return
    //   //   }

    //   //   if (!respuesta) {
    //   //     this.toastService.error('No se pudo enviar la solicitud')
    //   //     return
    //   //   }

    //   //   this.toastService.success('Solicitud enviada')
    //   //   this.buscar(this.paginationContext.CurrentPage);
    //   // })
    // })
  }

  downloadDocumentoPDF({ id_lsoft }) {
    const inputParams = {
      empresa_rut: this.rutEmpresa,
      id_lsoft,
    };

    const docIndexAll: number = this.listaDocumentosAll.findIndex((doc) => doc.id_lsoft === id_lsoft);
    const docAll: any = this.listaDocumentosAll[docIndexAll];
    docAll.additionalInfo.loadingPdf = true;
    this.log('docAll', docAll);

    const docIndex: number = this.listaDocumentos.findIndex((doc) => doc.id_lsoft === id_lsoft);
    const doc: any = this.listaDocumentos[docIndex];

    doc.additionalInfo.loadingPdf = true;
    this.log('doc', doc);
    this.documentoElectronicoService.urlPdfDocumentoRecibido(inputParams, ({ mensajes, respuesta }) => {
      doc.additionalInfo.loadingPdf = false;
      docAll.additionalInfo.loadingPdf = false;
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta);
    });
  }

  showModalAgregarDocumentoRecibido(doc: any) {
    const inputParams = {
      entidad: {
        cabecera: {
          rut_emisor: doc.rut_emisor,
          sucursal_codigo: this.sucursalCodigo,
          folio: doc.folio,
          tipo_dte_codigo: doc.tipo_dte_codigo,
          rut_receptor: doc.rut_receptor,
        },
      },
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.documentoService.obtenerDocumentoCompra(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null && respuesta !== undefined;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.ClienteSeleccion = respuesta;

      this.modalAgregarDocumentoRecibido.loadAndShow(this.ClienteSeleccion, doc, this.params);
    });
  }

  getItemToSearch($event) {
    this.params = $event;
    this.buscar(1);
  }
}
